import { render, staticRenderFns } from "./HelpQuickSkill.vue?vue&type=template&id=28f216d8&"
import script from "./HelpQuickSkill.vue?vue&type=script&lang=js&"
export * from "./HelpQuickSkill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports